import { MetaMovimentacaoSaldoPeriodo } from "@/Models/Domain/Relatorio/Financeiro/Conta/MovimentacaoSaldoPeriodo";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useMovimentacaoSaldoPeriodoListar({
    codConta,
    dataInicial,
    dataFinal,
    ...rest
}:QueryBasicaParam<AxiosResponse<MetaMovimentacaoSaldoPeriodo>, MetaMovimentacaoSaldoPeriodo, {
    codConta:number;
    dataInicial:Date;
    dataFinal:Date;
}>) {
    const query = RequestUtilitario.objectToQueryString({
        dataInicial,
        dataFinal
    });

    return useQuery({
        ...rest,
        queryKey : ["Domain", "Relatorio", "Financeiro", "Conta", codConta, "MovimentacaoSaldoPeriodo", {query}],
        queryFn : () => Axios.get<MetaMovimentacaoSaldoPeriodo>(`domain/relatorios/financeiro/conta/${codConta}/MovimentacaoSaldoPeriodo?${query}`),
        select(response) {
            var d = response.data;
            var r: MetaMovimentacaoSaldoPeriodo = {
                ...d,
                detalhes: d.detalhes.map(m => {
                    m.data = new Date(m.data as any);
                    return m;
                })
            }

            return r;
        },
        staleTime : 1000 * 60 * 0.25
    });
}